<template>
    <div>
        <v-row>
            <v-col cols="12" md="6">
                <v-simple-table dense>
                    <tbody>
                        <tr>
                            <th>Code</th>
                            <td>{{ value.code }}</td>
                        </tr>
                        <tr>
                            <th>Date</th>
                            <td>{{ value.date }}</td>
                        </tr>
                        <tr>
                            <th>Supplier</th>
                            <td>
                                {{ value.supplier ? value.supplier.display_name : null }}
                            </td>
                        </tr>
                        <tr>
                            <th>Account</th>
                            <td>
                                {{ value.account ? value.account.display_name : null }}
                            </td>
                        </tr>
                        <tr v-if="value.reference_id">
                            <th>Reference</th>
                            <td>
                                {{ value.reference_id ? value.reference_id : null }}
                            </td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </v-col>
            <v-col cols="12" md="6">
                <v-simple-table dense>
                    <tbody>
                        <tr>
                            <th>State</th>
                            <td>
                                <PStatus :state="value.state" v-if="value"/>
                            </td>
                        </tr>
                        <tr>
                            <th>Currency</th>
                            <td>
                                {{ value.currency ? value.currency.display_name : null }}
                            </td>
                        </tr>
                        <tr>
                            <th>Purchase Order</th>
                            <td>
                                <span class="text-decoration-underline font-weight-bold" @click="showPurchaseOrder" style="cursor: pointer">
                                {{ value.purchase_order? value.purchase_order.code : null }}
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="12">
                <v-simple-table dense>
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Item</th>
                            <th>Quantity</th>
                            <th>Price</th>
                            <th>Subtotal</th>
                            <th>Tax</th>
                            <th>Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(l, i) in lines" :key="i">
                            <td>{{i+1}}</td>
                            <td>{{ l.item }}</td>
                            <td>
                                {{ formatNumber(l.quantity) }}
                                {{ l.measure_unit }}
                            </td>
                            <td>{{ formatNumber(l.price) }}</td>
                            <td>{{ formatNumber(l.subtotal) }}</td>
                            <td>{{ formatNumber(l.tax) }}</td>
                            <td>{{ formatNumber(l.total) }}</td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </v-col>
        </v-row>
        <v-row no-gutters justify="end">
            <v-col cols="12" md="4">
                <v-simple-table dense>
                    <tbody>
                        <tr>
                            <th>Subtotal</th>
                            <td>{{ formatNumber(subtotal) }}</td>
                        </tr>
                        <tr>
                            <th>Tax</th>
                            <td>{{ formatNumber(tax) }}</td>
                        </tr>
                        <tr>
                            <th>Total</th>
                            <td class="font-weight-bold">
                                {{ formatNumber(total) }}
                            </td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-subheader></v-subheader>
        <v-divider></v-divider>
        <v-row no-gutters>
            <v-col cols="12" md="6">
                <v-simple-table dense>
                    <tbody>
                        <tr v-if="value.created_by">
                            <th>Created by</th>
                            <td>{{ value.created_by.name }}</td>
                        </tr>
                        <tr>
                            <th>Created At</th>
                            <td>{{ value.created_at }}</td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </v-col>
            <v-col cols="12" md="6">
                <v-simple-table dense>
                    <tbody>
                        <tr v-if="value.approved_by">
                            <th>Approved By</th>
                            <td>{{ value.approved_by.name }}</td>
                        </tr>
                        <tr>
                            <th>Created At</th>
                            <td>{{ value.created_at }}</td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { getTotal } from './../../utils/accounting';
import { formatNumber } from 'accounting';
import PStatus from './../common/PStatus'
export default {
    name: "PurchaseInvoice",
    components: {
        PStatus
    },
    props: {
        value: {
            type: Object
        }
    },
    computed: {
        lines() {
            if(!this.value.lines) return [];
            return this.value.lines.map(line => ({
                item: `${line.item.code} - ${line.item.name}`,
                description: line.description,
                quantity: line.quantity,
                measure_unit: line.measure_unit.name,
                price: line.price,
                subtotal: this.lineSubtotal(line),
                tax: this.lineTax(line),
                total: this.lineTotal(line),
                notes: line.notes
            }))
        },
        subtotal() {
            return getTotal(this.lines, "subtotal");
        },
        tax() {
            return getTotal(this.lines, "tax");
        },
        total() {
            return getTotal(this.lines, "total");
        }
    },
    data() {
        return {
            
        }
    },
    methods: {
        lineSubtotal(line) {
            return line.quantity * line.price;
        },
        lineTax(line) {
            return line.tax.rate * this.lineSubtotal(line);
        },
        lineTotal(line) {
            return this.lineSubtotal(line) + this.lineTax(line);
        },
        formatNumber(n) {
            return formatNumber(n, 2);
        },
        showPurchaseOrder() {
            this.$router.push({ name: "PurchaseOrderDisplay", params: { id: this.value.purchase_order.id } });
        }
    }
}
</script>

<style></style>
